import React, { CSSProperties } from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'

import { ACFImageType } from '@contracts/Components/ACF'

interface Props {
	image: ACFImageType
	altText: string
	loading?: 'eager' | 'lazy'
	objectFit?: CSSProperties['objectFit']
	className?: string
}

const Image = (props: Props) => {
	const className = props.className ? props.className : ''

	if (props.image.mimeType == 'image/svg+xml') {
		return <img src={props.image.localFile.publicURL} alt={props.altText} className={className} />
	} else if (props.image.localFile.childImageSharp) {
		return (
			<GatsbyImage
				image={props.image.localFile.childImageSharp.gatsbyImageData}
				alt={props.altText}
				className={className}
				loading={props.loading}
				objectFit={props.objectFit}
			/>
		)
	}

	return <div>Image</div>
}

Image.defaultProps = {
	loading: 'lazy',
	objectFit: 'cover',
}

Image.defaultProps = {
	loading: 'lazy',
}

export default Image
